export default "__VITE_ASSET__DnkLMQZm__"